import { Account } from '@/domain/usecases'
import { formatDependentRequestSettings } from '@/data/services/dependent/dependent-service-utils'
import { requestSettingsQueryOptions } from '@/data/services/request-settings/request-settings-service'
import { queryClient } from '@/infra/http'

/**
 * Loads dependent configuration settings for company manager
 * Fetches company dependent request settings
 */
export async function loadCompanyManagerDependentConfiguration(account: Account.Model) {
  // staleTime 0: a tela de configuração edita esses dados, então sempre busca a versão atual.
  const settings = await queryClient.fetchQuery({
    ...requestSettingsQueryOptions(account.company.uniqueId),
    staleTime: 0
  })
  const formattedSettings = formatDependentRequestSettings(settings)

  return {
    ...formattedSettings,
    plans: formattedSettings.plans || [],
    upgradePlans: formattedSettings.upgradePlans || []
  }
}
